module.exports = __webpack_public_path__ + "src/assets/img/icon_2.4bd25c0a.svg";